// extracted by mini-css-extract-plugin
export default {"root":"_2y7P9"};